<template>
  <div class="pb-6 px-6 pt-0" style="width: 100%;">
    <CreateUserForm :state="dialog" :roles="roles" @closeDialog="close" @refresh="refresh" />
    <div class="component-title py-6 d-flex" style="width: 100%">
      <div>Nhân viên sale</div>
    </div>
    <div class="d-flex justify-end align-center mb-6">
      <v-btn color="primary" @click="openCreate"> <v-icon left>mdi-account-plus-outline</v-icon>Tạo nhân viên</v-btn>
    </div>
    <v-card class="pa-6 elevation-1  mb-6">
      <SaleFilter :roles="roles" @onFilterChanged="onFilterChanged" />
    </v-card>

    <v-card class="elevation-1">
      <SaleTable :users="filteredUsers" ref="activeCodeTable" />
    </v-card>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import SaleTable from './SaleTable.vue'
import SaleFilter from './SaleFilter.vue'
import CreateUserForm from './CreateUserForm.vue'

export default {
  components: {
    SaleFilter,
    SaleTable,
    CreateUserForm
  },
  data() {
    return {
      dialog: false,
      filteredUsers: [],
      rolesIds: [],
      roles: []
    }
  },
  async created() {
    this.$loading.active = true
    const roles = await this.fetchRoles({})
    console.log('roles', roles)
    let filteredRoles = roles.filter(role => role.type === 'admin' || role.type === 'sale' || role.type === 'saleAdmin')
    this.roles = filteredRoles
    const roleIds = filteredRoles.map(role => role.id)
    this.rolesIds = roleIds
    let routeQuery = {}
    if (this.$route.query) {
      routeQuery = this.$route.query
    }
    await this.getUsers({role: roleIds, ...routeQuery})
    this.$loading.active = false
  },

  computed: {
    ...mapGetters('auth', ['user']),
    ...mapGetters('user', ['users'])
  },
  methods: {
    ...mapActions('user', ['countUsers', 'fetchUsers']),
    ...mapActions('role', ['fetchRoles']),
    async getUsers(query) {
      this.$loading.active = true
      this.filteredUsers = await this.fetchUsers({...query, role: this.rolesIds})
      if (Object.keys(this.$route.query).length !== 0) {
        this.$router.replace({
          path: this.$route.path,
          query: {}
        })
      }

      this.$loading.active = false
    },
    async onFilterChanged(query) {
      this.$loading.active = true

      await this.getUsers({...query})
      this.$loading.active = false
    },
    openCreate() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    refresh() {
      this.getUsers({role: this.rolesIds})
    }
  }
}
</script>

<style scoped>
.component-title {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
  color: #0d47a1;
}
</style>
